import React, { Component }  from 'react';
import {format} from 'react-string-format';
import Game from "./Game";
import * as ReactDOM from 'react-dom';
import {NavLink} from "react-router-dom";
import {withRouter} from "./withRouter";
import {Col, Container, Row} from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";

class CategoriesNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            items: []
        };
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + "/customer/game/categories")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        items: result
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    render() {
        const { error, isLoaded, items } = this.state;

        let content = null;

        if (error) {
            content = <div>{error ? <div className="alert alert-danger">
                <p>Session token has expired. Please, <a href="/account">login</a> again</p>
            </div> :<empty/>}</div>;
        } else if (!isLoaded) {
            content = <div>Loading...</div>;
        } else {
            content =
                (<div style={{
                    paddingTop: 50,
                    paddingBottom: 50,
                    borderRadius: 8,
                        backgroundColor: "white",
                        width: "100%"
                }}>
                    <div>
                        <center>
                            {items.map(item => (
                            <div style={{
                                marginTop: 20,
                                backgroundColor: "black",
                                borderRadius: 9,
                                width: "100%"
                            }}>
                                <img style={{
                                    opacity: 0.6,
                                    width: "100%",
                                    height: "auto",
                                    borderRadius: 9,

                                    //backgroundRepeat: "no-repeat",
                                         //backgroundImage: `url("https://easy-street.s3.us-east-2.amazonaws.com/upload/app/3/data/bg/remakePanorama.png")`
                                }}
                                     //src={"https://easy-street.s3.us-east-2.amazonaws.com/upload/app/3/data/bg/remakePanorama.png"}
                                     src={item.games.length > 0 && item.games[0].game_page ? item.games[0].game_page.background_image_url : "https://wallpaper-house.com/data/out/8/wallpaper2you_287091.png"}
                                >
                                </img>
                                <hr style={{
                                    width: "90%",
                                    marginRight: "5%",
                                    height: 5,
                                    backgroundColor: "white",

                                }}/>
                                <div style={{
                                    zIndex:2,
                                    color: "white",
                                    marginBottom: 0
                                }}>
                                    <h1>{item.name}</h1>
                                    {item.downloads_count} {item.downloads_count > 1 ? "downloads total" : "download"}
                                    <br/>
                                    {item.games.length} {item.games.length > 1 ? "apps total" : "app"}
                                    <br/>
                                    <br/>
                                    <NavLink
                                        to={"/categories/" + item.id}
                                        className="btn btn-light"
                                    >
                                        Open
                                    </NavLink>
                                    <br/>
                                    <br/>
                                </div>
                            </div>
                        ))}
                        </center>
                    </div>
                </div>
            );
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>;
    }
}

export default withRouter(CategoriesNew);
